import { hotRank } from '../data';
import SectionHeader from './SectionHeader';

const rankMedal = ['bg-primary-500 text-background-50', 'bg-accent-500 text-background-50', 'bg-secondary-400 text-background-50'];
const trendIcon: Record<string, { icon: string; cls: string }> = {
  up: { icon: 'ri-arrow-up-line', cls: 'text-primary-600' },
  down: { icon: 'ri-arrow-down-line', cls: 'text-accent-600' },
  new: { icon: 'ri-sparkling-2-fill', cls: 'text-secondary-600' },
};

function formatHeat(n: string) {
  return n;
}

export default function HotRank() {
  const list = hotRank;

  return (
    <section id="hot" className="mx-auto w-full max-w-7xl scroll-mt-20 px-4 py-16 md:px-6 md:py-20">
      <SectionHeader kicker="Trending" title="今日吃瓜热榜" desc="实时滚动的热门话题排行，热度最高的吃瓜方向一眼掌握。" />
      <div className="mt-2 grid grid-cols-1 gap-3 sm:grid-cols-2">
        {list.map((item, idx) => {
          const badgeCls = idx < 3 ? rankMedal[idx] : 'bg-background-200 text-foreground-600';
          const t = trendIcon[item.trend];
          return (
            <article
              key={item.id}
              className="group flex items-center gap-4 rounded-2xl border border-background-200/80 bg-background-100/50 p-4 transition hover:border-primary-200 hover:bg-background-50"
            >
              <span className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-xl font-display text-lg ${badgeCls}`}>
                {idx + 1}
              </span>
              <div className="min-w-0 flex-1">
                <a href="#category" onClick={() => document.getElementById(`cat-${item.catId}`)?.scrollIntoView({ behavior: 'smooth' })} className="line-clamp-2 font-medium text-foreground-900 transition group-hover:text-primary-700">
                  {item.title}
                </a>
                <div className="mt-2 flex flex-wrap items-center gap-2 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1 rounded-full bg-background-200/80 px-2.5 py-0.5">
                    <i className={`${t.icon} ${t.cls}`} aria-hidden="true"></i>
                    {formatHeat(item.heat)}
                  </span>
                  <span>{item.time}</span>
                  <span className="ml-auto inline-flex items-center gap-1 rounded-full bg-accent-100 px-2.5 py-0.5 font-medium text-accent-800">
                    {item.cat}
                  </span>
                </div>
              </div>
              <i className="ri-arrow-right-up-line shrink-0 text-foreground-300 transition group-hover:text-primary-600" aria-hidden="true"></i>
            </article>
          );
        })}
      </div>
    </section>
  );
}